<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Adaugă un nou document(Intern)</h1>
        <button class="action-buttons-side" (click)="closeDialog()">x</button>
    </div>
    <div *ngIf="docData" class="mb-2">
        <span style="color: red; font-size: 16px;">(Registru selectat: <strong><u>{{ selectedSerieDocument
                    }}</u></strong>)</span>
    </div>
    <form [formGroup]="form">
        <h3 class="m-0">Informații</h3>
        <mat-divider class="divider-section"></mat-divider>
        <br>
        <div *ngIf="docData" class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Tip emitere număr document nou </mat-label>
                    <mat-select formControlName="new_number">
                        <mat-option *ngFor="let option of newNumberOptions"
                            [value]="option.id">{{option.name}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['new_number'].valid && form.controls['new_number'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="!docData" class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Registru/Serie/Lot</mat-label>
                    <mat-select formControlName="id_serie" (selectionChange)="onRegisteActiveSelected($event.value)">
                        <mat-option *ngFor="let option of registreActiveSwitch"
                            [value]="option.id">{{option.name}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_serie'].valid && form.controls['id_serie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <ng-container *ngIf="registruOficialGeneralValue != form.get('id_serie')?.value && showRegistreFields">
            <div class="row">
                <div [ngClass]="form.get('registratura_number_type')?.value === 1 ? 'col-md-12' : 'col-md-6'">
                    <mat-form-field appearance="fill">
                        <mat-label>Formalitate inregistrare</mat-label>
                        <mat-select formControlName="registratura_number_type"
                            (selectionChange)="onRegistraturaTypeSelected($event.value)">
                            <mat-option *ngFor="let option of registreOptions"
                                [value]="option.id">{{option.name}}</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="!form.controls['registratura_number_type'].valid && form.controls['registratura_number_type'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6" *ngIf="form.get('registratura_number_type')?.value === 2">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr Document (Răspuns/Ieșire)</mat-label>
                        <input type="number" matInput formControlName="registratura_number" />
                        <mat-error
                            *ngIf="!form.controls['registratura_number'].valid && form.controls['registratura_number'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="registruOficialGeneralValue != form.get('id_serie')?.value &&  showProceduraField">
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill">
                        <mat-label>Procedură ieșire document</mat-label>
                        <mat-select formControlName="exit_document_format"
                            (selectionChange)="onProceduraIesireSelected($event.value)">
                            <mat-option *ngFor="let option of proceduriDocumentOptions"
                                [value]="option.id">{{option.name}}</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="!form.controls['exit_document_format'].valid && form.controls['exit_document_format'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Tip Document</mat-label>
                    <input matInput [formControl]="tipDocumenteControl" [matAutocomplete]="autoTipDocumente"
                        (blur)="onTipDocumenteBlur()" />
                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                    <mat-autocomplete #autoTipDocumente="matAutocomplete" [displayWith]="displayTipDocumente"
                        (optionSelected)="onTipDocumenteSelected($event.option.value)">
                        <mat-option *ngIf="showTipDocumenteMessage" disabled>
                            <span *ngIf="!tipDocumenteControl.value || tipDocumenteControl.value.length < 2">
                                Vă rugăm să introduceți 2 caractere sau mai multe
                            </span>
                            <span
                                *ngIf="isTipDocumenteLoading && tipDocumenteControl.value && tipDocumenteControl.value.length >= 2">Căutare...</span>
                            <span
                                *ngIf="!isTipDocumenteLoading && tipDocumenteLoadComplete && tipDocumente.length === 0 && tipDocumenteControl.value && tipDocumenteControl.value.length >= 2">
                                Nu au fost găsite rezultate
                            </span>
                        </mat-option>

                        <mat-option *ngFor="let doc of tipDocumente" [value]="doc">
                            {{ doc.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="!tipDocumenteControl.valid && tipDocumenteControl.touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Observații</mat-label>
                    <textarea matInput formControlName="observatii"
                        placeholder="Observații/Mențiuni/Conținut..."></textarea>
                    <mat-hint style="color: red;">
                        <strong><i>Aici se notează observațiile/mențiunile/conținutul
                                documentului/dosarului!</i></strong>
                    </mat-hint>
                    <mat-error *ngIf="!form.controls['observatii'].valid && form.controls['observatii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <mat-form-field appearance="fill">
                    <mat-label>Cuvinte cheie</mat-label>
                    <input matInput type="text" formControlName="keywords" />
                    <mat-error *ngIf="!form.controls['keywords'].valid && form.controls['keywords'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field appearance="fill">
                    <mat-label>Număr Pagini</mat-label>
                    <input matInput type="number" formControlName="no_pages" />
                    <mat-error *ngIf="!form.controls['no_pages'].valid && form.controls['no_pages'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <ng-container *ngIf="registruOficialGeneralValue == form.get('id_serie')?.value || 
            (registruOficialGeneralValue != form.get('id_serie')?.value && showFormFiles)">
            <h3 class="m-0">Încărcați Documente <span class="text-danger">(*)</span></h3>
            <mat-divider class="divider-section"></mat-divider>
            <br>
            <form [formGroup]="formFiles">
                <div class="solicitare-card__upload mb-2">
                    <div class="solicitare-card__upload-header">
                        <p class="upload-text">Documente</p>
                        <button class="upload-btn" (click)="fileInput.click()" type="button">
                            <mat-icon class="upload-icon">cloud_upload</mat-icon>
                            ÎNCARCĂ
                        </button>
                    </div>
                    <div class="solicitare-card__upload-files" *ngIf="
                        formFiles.value.files &&
                        formFiles.value.files.length > 0 &&
                        !uploading
                    ">
                        <div class="solicitare-card__upload-file" *ngFor="
                            let uploadedFile of formFiles.value.files;
                            let i = index
                        ">
                            <span class="solicitare-card__upload-file-name">
                                {{
                                uploadedFile.original_name.length > 30
                                ? (uploadedFile.original_name | slice : 0 : 30) + ".."
                                : uploadedFile.original_name
                                }}
                            </span>
                            <div class="d-flex gap-4 align-items-center">
                                <button class="solicitare-card__upload-file-view" type="button"
                                    matTooltip="Vizualizează fișierul" (click)="downloadFile(uploadedFile)">
                                    <mat-icon class="btn-icon">visibility</mat-icon>
                                    <span class="btn-text">Vizualizează</span>
                                </button>
                                <button class="solicitare-card__upload-file-delete" type="button"
                                    matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                                    <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="solicitare-card__upload-files" *ngIf="
                        formFiles.value.files &&
                        formFiles.value.files.length === 0 &&
                        !uploading
                    ">
                        <div class="solicitare-card__upload-file">
                            <div class="w-100 text-center">
                                <strong><i>Lipsă înregistrări</i></strong>
                            </div>
                        </div>
                    </div>
                    <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                        *ngIf="uploading"></mat-spinner>

                    <input type="file"
                        accept=".png, .jpg, .jpeg, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ods, .odt, .heic"
                        id="upload-file-input-0" #fileInput name="fileInput" (change)="addFile($event)" multiple
                        style="display: none" />
                </div>
            </form>
        </ng-container>

        <ng-container *ngIf="showFormDestinatie">
            <h3 class="m-0">Destinație <span class="text-danger">(*)</span></h3>
            <mat-divider class="divider-section"></mat-divider>
            <br>
            <form [formGroup]="formDestinatie">
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Instituție/Direcție</mat-label>
                            <input matInput [formControl]="directiiDestinatieControl"
                                [matAutocomplete]="autoDirectiiDestinatie" (blur)="onDirectiiDestinatieBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoDirectiiDestinatie="matAutocomplete"
                                [displayWith]="displayDirectiiDestinatie"
                                (optionSelected)="onDirectiiDestinatieChange($event.option.value)">
                                <mat-option *ngIf="filteredDirectiiDestinatie.length === 0" disabled>
                                    Nu au fost găsite rezultate
                                </mat-option>
                                <mat-option *ngFor="let directie of filteredDirectiiDestinatie" [value]="directie">
                                    {{ directie.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Compartiment/Departament</mat-label>
                            <input matInput [formControl]="compartimenteDestinatieControl"
                                [matAutocomplete]="autoCompartimenteDestinatie"
                                (blur)="onCompartimenteDestinatieBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoCompartimenteDestinatie="matAutocomplete"
                                [displayWith]="displayCompartimenteDestinatie"
                                (optionSelected)="onCompartimenteDestinatieSelected($event.option.value)">
                                <mat-option *ngIf="showCompartimenteDestinatieMessage" disabled>
                                    <span
                                        *ngIf="!compartimenteDestinatieControl.value || compartimenteDestinatieControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isCompartimenteDestinatieLoading && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isCompartimenteDestinatieLoading && compartimenteDestinatieLoadComplete && compartimenteDestinatie.length === 0 && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let compartiment of compartimenteDestinatie" [value]="compartiment">
                                    {{ compartiment.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Alegeți un operator</mat-label>
                            <mat-select formControlName="user_id"
                                (selectionChange)="onOperatoriDestinatieChange($event.value)">
                                <!-- <mat-form-field class="px-2 sticky-input">
                                <input matInput [formControl]="operatoriDestinatieControl"
                                    (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field> -->

                                <mat-option [value]="-1">-- Alegeți --</mat-option>

                                <mat-option *ngFor="let operator of filteredOperatoriDestinatie" [value]="operator.id">
                                    {{ operator.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <button (click)="addDestinatieToTableData()" class="btn-search my-2 default-btn">
                    Adaugă Destinație
                </button>
            </form>

            <div *ngIf="this.showFormDestinatie && this.tableData.length === 0" class="my-2">
                <mat-error>Adăugați minim o destinație.</mat-error>
            </div>

            <div class="row m-2">
                <table *ngIf="tableData.length > 0">
                    <thead>
                        <tr>
                            <th class="pe-1">Crt.</th>
                            <th class="pe-1">Instituție/Direcție</th>
                            <th class="pe-1">Departament/Compartiment</th>
                            <th class="pe-1">Responsabil</th>
                            <th class="pe-1">Doc Original?</th>
                            <th class="pe-1">#</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of tableData; let i = index" class="table-row">
                            <td class="py-2 pe-1">{{ i + 1 }}</td>
                            <td class="py-2 pe-1">{{ row.directie_name || 'n/a' }}</td>
                            <td class="py-2 pe-1">{{ row.compartiment_name || 'n/a' }}</td>
                            <td class="py-2 pe-1">{{ row.user_name || 'n/a' }}</td>
                            <td class="py-2 pe-1">
                                <button type="button" class="action-btn update_status_active"
                                    [ngClass]="(row.dosar_original ? 'action-success' : 'action-danger')"
                                    (click)="checkDocOriginal(i)">
                                    <img class="btn-img"
                                        [src]="row.dosar_original ? '/assets/icons/check-white.svg' : '/assets/icons/close-white.svg'" />
                                </button>
                            </td>
                            <td class="py-2 pe-1">
                                <button class="action-btn delete" (click)="deleteTableDataRow(i)">
                                    <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete" />
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>

        <div class="row">
            <h5 class="mb-3"><span class="text-danger">*</span> <i>Câmpuri obligatorii</i></h5>
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" (click)="submitForm()">
                    Adaugă
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-fixed" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>